import { render, staticRenderFns } from "./CreateEditProductStore.vue?vue&type=template&id=563bf71d&scoped=true"
import script from "./CreateEditProductStore.vue?vue&type=script&lang=js"
export * from "./CreateEditProductStore.vue?vue&type=script&lang=js"
import style0 from "./CreateEditProductStore.vue?vue&type=style&index=0&id=563bf71d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563bf71d",
  null
  
)

export default component.exports